// extracted by mini-css-extract-plugin
module.exports = {"default":"_99551c8aa8--default--xC7w5","light":"_99551c8aa8--light--U0vr4","outline":"_99551c8aa8--outline--W8v_0"};